import React, { useEffect, useState, useContext } from "react";
import Module from "../../../../templates/components/Module";
import moment from "moment";
import Utilities from "../../../../../services/commonservice/utilities";
import Table2 from "../../../../templates/components/Table2";
import DatePicker from "../../../../templates/components/DatePicker";
import DimLoader from "../../../../templates/components/DimLoader";
import { store } from "../../../../../context/StateProvider";
import InvoiceService from "../../../../../services/api/invoice.service";
import PatientSelector from "../../../../templates/components/PatientSelector";
import ReportService from "../../../../../services/api/report.service";
import PracticeLocationSelector from "../../../../templates/components/PracticeLocationSelector";

const MembershipReportTable = (props) => {
  // context state and dispatch 
  const globalStateAndDispatch = useContext(store)
  const state = globalStateAndDispatch.state
  const [membershipReportList, setMembershipReportList] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [initialMessage, setInitialMessage] = useState(true)
  const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)
  const [locationId, setLocationId] = useState(state.practiceLocationId || null)
  const [patientId, setPatientId] = useState()

  const onPatientChange = (newPatientId) => {
    setPatientId(newPatientId)
  }
  const onLocationChanged = (newLocationId) => {
    setLocationId(newLocationId)
  }
  const membershipReportLookup = () => {
    let reqObj = {};
    if (locationId) {
      reqObj.PracticeLocationId = locationId
    }
    if (patientId) {
      reqObj.PatientId = patientId
    }
    setIsLoader(true)
    setInitialMessage(false);
    ReportService.getMembershipReportReport(reqObj)
      .then((res) => {
        //console.log(JSON.stringify(res))
        setMembershipReportList(res);
        setIsLoader(false);
      })
      .catch((err) => {
        setMembershipReportList(res);
        setIsLoader(false);
      });
  };

  const columns = [
    {
      id: "patientFirstName",
      Header: "First Name",
      accessor: (pp) => pp.patientFirstName,
    },
    {
      id: "patientLastName",
      Header: "Last Name",
      accessor: (pp) => pp.patientLastName,
    },
    {
      id: "membershipName",
      Header: "Membership",
      accessor: (pp) => pp.membershipName,
    },
    {
      id: "membershipStartsOn",
      Header: "Starts On",
      accessor: (pp) =>
        pp.membershipStartsOn
          ? moment(pp.membershipStartsOn).format("MM/DD/YYYY")
          : '',
    },
    {
      id: "membershipExpiresOn",
      Header: "Expires On",
      accessor: (pp) =>
        pp.membershipExpiresOn
          ? moment(pp.membershipExpiresOn).format("MM/DD/YYYY")
          : '',
    },
    {
      id: "membershipPeriodUnit",
      Header: "Period",
      accessor: (pp) => pp.membershipPeriodUnit,
    },
    {
      id: "lastPaymentDate",
      Header: "Last Payment Date",
      accessor: (pp) =>
        pp.lastPaymentDate
          ? moment(pp.lastPaymentDate).format("MM/DD/YYYY")
          : '',
    },
    {
      id: "lastPaymentStatusLabel",
      Header: "Last Payment Status",
      accessor: (pp) => pp.lastPaymentStatusLabel,
    },
    {
      id: "nextPaymentDate",
      Header: "Next Payment Date",
      accessor: (pp) =>
        pp.nextPaymentDate
          ? moment(pp.nextPaymentDate).format("MM/DD/YYYY")
          : '',
    },
    {
      id: "nextPaymentMaskedCard",
      Header: "Masked Card",
      accessor: (pp) => pp.nextPaymentMaskedCard,
    },
    {
      id: "nextPaymentCardExpiry",
      Header: "Card Expiry",
      accessor: (pp) => pp.nextPaymentCardExpiry,
    },
    {
      id: "nextPaymentCardStatus",
      Header: "Card Status",
      accessor: (pp) => pp.nextPaymentCardStatus,
    },
  ];


  return (
    <>
      {isLoader &&
        <DimLoader loadMessage="Processing" />
      }
      <div className="row d-flex g-3">
        <div className="col-12 m-p-0">
          <Module title="Filters">
            <div className='row d-flex'>
              <div className='col-12 mx-0  report-filters'>
                <div className="d-flex row justify-content-center align-items-end">
                  <div className='col-md col-12'>
                    <div className='ui field'>
                      <label>Practice Location</label>
                      <PracticeLocationSelector isClearable={isLocationClearable} dontResetState={true} onSelected={onLocationChanged} />
                    </div>
                  </div>
                  <div className='col-md col-12'>
                    <div className='ui field'>
                      <label>Patient</label>
                      <PatientSelector onSelected={onPatientChange} showAddPatient={false} />
                    </div>
                  </div>
                  <div className="col-md-auto col-12"><button className="btn btn-primary" onClick={e => { e.preventDefault(); setMembershipReportList(); membershipReportLookup() }} title="Pull Report"><i className="icon arrow circle right" /></button></div>
                </div>
              </div>
            </div>
          </Module>
        </div>
        <div className="col-12 m-p-0">
          <Module title="Membership">
            <Table2
              export
              searchable
              title="Membership"
              data={membershipReportList}
              loading={isLoader}
              columns={columns}
              initialMessage={initialMessage}
            />
          </Module>
        </div>
      </div>
    </>
  );
};

export default MembershipReportTable;
